import "./style/ScrollMorePopup.scss";

interface IScrollMorePopupProps {
  handleCloseScrollMore: () => void;
}

export const ScrollMorePopup = ({ handleCloseScrollMore }: IScrollMorePopupProps) => {
  return (
    <div className="ScrollMorePopup">
      <div className="ScrollMorePopup-Arrow">
        <div className="Arrow">
          <div className="Arrow-Chevron"></div>
          <div className="Arrow-Chevron"></div>
          <div className="Arrow-Chevron"></div>
        </div>
        <span className="ScrollMorePopup-Text">Scroll for more</span>
        <button className="ScrollMorePopup-Btn" onClick={handleCloseScrollMore}>Dismiss</button>
      </div>
    </div>
  );
};
